export default "\n\n    <!-- <div class=\"loader\"></div> -->\n\n";